<template>
  <div>
    <vx-card class="mb-4">
      <div class="w-full flex flex-no-wrap">
        <div class="w-1/2">
          <h5 class="mb-4">Device Assignment Settings</h5>
          <div class="table-row w-full mb-5">
            <div class="table-cell w-2/5 p-4">Request Id</div>
            <div class="table-cell w-3/5 p-4">{{device_assignment.code}}</div>
          </div>
          <div class="table-row w-full mb-5">
            <div class="table-cell w-2/5 p-4">Merchant</div>
            <div class="table-cell w-3/5 p-4">{{device_assignment.merchants.full_name}}</div>
          </div>
          <div class="table-row w-full mb-5">
            <div class="table-cell w-2/5 p-4">Merchant Code</div>
            <div class="table-cell w-3/5 p-4">{{device_assignment.merchants.code}}</div>
          </div>
          <div class="table-row w-full">
            <div class="table-cell w-2/5 p-4">
              Description
              <span class="text-danger">*</span>
            </div>
            <div class="table-cell w-3/5 p-4">{{device_assignment.notes}}</div>
          </div>
          <div class="table-row w-full">
            <div class="table-cell w-2/5 p-4">
              Tags
              <span class="text-danger">*</span>
            </div>
            <div class="table-cell w-3/5 p-4">
              <vue-tags-input
                id="lnk-tags"
                v-model="tag"
                :tags="device_assignment.tags"
                @tags-changed="newTags => tags = newTags"
                disabled
              />
              <span class="text-danger text-sm">{{ errors.first('tags') }}</span>
            </div>
          </div>
          <div class="table-row w-full">
            <div class="table-cell w-2/5 p-4">
              Device Type
              <span class="text-danger">*</span>
            </div>
            <div class="table-cell w-3/5 p-4">
              <vs-select
                id="cbo-device-type"
                class="w-full"
                placeholder="Device Type"
                v-validate="'required'"
                name="device type"
                vs-multiple
                autocomplete
                v-model="device_assignment.device_type_id"
                disabled
              >
                <vs-select-item
                  v-bind:id="'cbo-device-type-list-'+index"
                  :key="index"
                  :value="item.id"
                  :text="item.name"
                  v-for="(item,index) in device_type"
                />
              </vs-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('device type')"
              >{{ errors.first('device type') }}</span>
              <span class="text-danger text-sm">{{ errors.first('device type') }}</span>
            </div>
          </div>
          <div class="table-row w-full mb-5">
            <div class="table-cell w-2/5 p-4">Device Requested</div>
            <div class="table-cell w-3/5 p-4">{{device_assignment.device_qty}}</div>
          </div>
        </div>

        <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
          <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login" />
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div id="ag-grid-demo">
        <vx-card>
          <!-- TABLE ACTION ROW -->
          <div class="flex flex-wrap justify-between items-center">
            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <vs-dropdown id="ddl-page-limit" vs-trigger-click class="cursor-pointer">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span
                    class="mr-2"
                  >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                    <span>20</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                    <span>150</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
              <vs-input
                class="mb-4 md:mb-0 mr-4"
                v-model="searchQuery"
                @input="updateSearchQuery"
                placeholder="Search..."
              />
              <!-- <vs-button class="mb-4 md:mb-0 mr-4" icon="add" :to="'/device/assignment/detail'">Add Request</vs-button> -->
              <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
            </div>
          </div>
          <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="dataTrx"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :floatingFilter="true"
            :pagination="true"
            :paginationPageSize="limit"
            :suppressPaginationPanel="true"
            :row-height="rowHeight"
            @column-resized="onColumnResized"
            :enableCellTextSelection="true"
          ></ag-grid-vue>
          <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import AxiosCall from "@/global/AxiosCall";
import FileAPI from "@/network/api/FileAPI";
import { url } from "@/configs/apiUrl";
import VueTagsInput from "@johmun/vue-tags-input";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import UnpairTableAgGridComponent from "@/components/cell-render-component/UnpairTableAgGridComponent";

export default {
  components: {
    AgGridVue,
    VueTagsInput,
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: null,
      columnDefs: null,
      rowHeight: null,
      dataTrx: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      device_assignment: {
        id: "",
        code: "",
        notes: "",
        tags: [],
        device_type_id: "",
        device_qty: "",
        merchants: {
          full_name: ""
        }
      },
      tag: "",
      device_type: [],
      documents: [
        {
          name: "Configuration",
          file_name: "",
          url: ""
        }
      ],
      file: {}
    };
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      }
    }
  },
  methods: {
    warning(title, text) {
      this.$vs.notify({
        title: title,
        text: text,
        color: "warning",
        position: "top-right"
      });
    },
    success(title, text) {
      this.$vs.notify({
        title: title,
        text: text,
        color: "success",
        position: "top-right"
      });
    },
    onColumnResized() {
      this.gridOptions.api.resetRowHeights();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    unpairRecord(id) {
      this.openLoading();
      AxiosCall.Put(url.svd.device_assignment.unpair + "/" + id).then(
        response => {
          if (response.code === 200) {
            this.$vs.loading.close();
            this.success("Unpair success", "Unpair device success");
            setTimeout(() => {
              this.fetchData(this.page, this.limit);
            }, 1000);
          } else {
            this.$vs.loading.close();
            this.warning("Unpair failed", "Unpair device failed");
          }
        }
      );
    },
    fetchData(page, limit) {
      this.openLoading();
      //let newPage = page;
      // if (this.dataCount != 0) {
        // let totalPages = Math.ceil(this.dataCount / limit);
        // if (page > totalPages) {
        //   newPage = totalPages;
        // }
      // }

      AxiosCall.Get(
        url.svd.device_assignment.detail + "?request_id=" + this.$route.query.id
      )
        .then(resp => {
          this.$vs.loading.close();
          this.dataTrx = [];
          if (resp.data.data.length != 0) {
            let no = 1;
            for (let data of resp.data.data) {
              data.no = no;
              let config_pay_acc = "";
              if (
                data.config !== null &&
                data.config.payment_acceptance !== null
              ) {
                let pay_acc = data.config.payment_acceptance;
                for (let i in pay_acc) {
                  if (i == 0) {
                    config_pay_acc += "- " + pay_acc[i].name;
                  } else {
                    config_pay_acc += "\n- " + pay_acc[i].name;
                  }
                }
                data.config.payment_acceptance = config_pay_acc;
              }

              this.dataTrx.push(data);
              no++;
            }

            this.dataCount = resp.data.total;
            this.page = page;
            if (limit >= this.dataCount) {
              this.limit = this.dataTrx.length;
            } else {
              this.limit = limit;
            }

            this.gridApi.paginationSetPageSize(this.limit);
            this.totalPage = resp.data.lastPage;
          }
        })
        .catch(e => {
          this.$vs.loading.close();
          console.log(e);
        });
    },
    backPage() {
      this.$router.push({name:'devicesAssignment'});
    },
    submitRequest() {
      this.openLoading();
      FileAPI.UploadConfig(this.file)
        .then(result => {
          this.$vs.loading.close();
          if (result.code == 200) {
            let status = true;
            this.$router.push({
              name: "devicesAssignment",
              params: { status: status }
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
        });

      // const payload = {
      //   merchantInfo: this.merchantInfo,
      //   notify: this.$vs.notify
      // };
      //this.$store.dispatch("auth/registerUser", payload);
    },
    openLoading() {
      this.$vs.loading({
        type: "default"
      });
    },
    handleFileUpload(file) {
      let payload = {
        file: file,
        data: {
          id: this.device_assignment.id
        }
      };
      this.file = payload;
    },
    handleDelete(file, title) {
      if (title === this.documents[0].name) {
        this.documents[0].file_name = "";
        this.documents[0].url = "";
      }
    }
  },
  beforeMount() {
    this.defaultColDef = {
      sortable: true,
      editable: false,
      resizable: true,
      suppressMenu: true
    };
    this.columnDefs = [
      {
        headerName: "Device ID",
        field: "code",
        width: 300,
        filter: true,
        pinned: "left"
      },
      {
        headerName: "Serial Number",
        field: "serial_number",
        filter: true,
        width: 300
      },
      {
        headerName: "Device Name",
        field: "name",
        filter: true,
        width: 300
      },
      {
        headerName: "Device Type",
        field: "device_request.device_type.name",
        filter: true,
        width: 300
      },
      {
        headerName: "Description",
        field: "notes",
        filter: true,
        width: 300
      },
      {
        headerName: "Payment Acceptance",
        field: "config.payment_acceptance",
        editable: false,
        cellClass: "cell-wrap-text",
        // cellRendererFramework:UnpairTableAgGridComponent,
        autoHeight: true,
        filter: true,
        width: 300
      },
      {
        headerName: "Status Provision",
        field: "status_provision",
        filter: true,
        cellRendererFramework: UnpairTableAgGridComponent,
        width: 200
      },
      {
        headerName: "Status Device",
        field: "status_device",
        cellRendererFramework: UnpairTableAgGridComponent,
        filter: true,
        width: 200
      },
      {
        headerName: "Action",
        field: "id",
        filter: false,
        cellRendererFramework: UnpairTableAgGridComponent,
        width: 300
      }
    ];
    this.rowHeight = 275;
  },
  mounted() {
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: '#f9f9f9' }
      }
    }
    this.gridOptions.rowHeight = 42;
    
    AxiosCall.Get(url.svd.device_type.selection)
      .then(response => {
        if (response.code == 200) {
          this.device_type = response.data;
        } else {
          this.warning("Get device type", "Fail get device type");
        }
      })
      .catch(() => {});

    AxiosCall.Get(
      url.svd.device_request.detail + "/" + this.$route.query.id
    ).then(response => {
      this.device_assignment = response.data[0];
      this.device_assignment.tags = [];
      for (let i in response.data[0].tag) {
        this.device_assignment.tags.push({ text: response.data[0].tag[i] });
      }
    });

    this.$root.$on("unpair-from-ActionTableAgGridComponent", val => {
      this.unpairRecord(val);
    });
    this.gridApi = this.gridOptions.api;
  }
};
</script>

<style lang="scss">
.con-input-upload {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 73px;
  text-align: left;
  margin: 0px;
  flex-direction: column;
  .text-input {
    text-align: left;
    width: 80%;
    display: block;
  }
  .vs-upload--button-upload {
    text-align: right;
    width: 20%;
    display: block;
    right: 0;
    bottom: auto;
    margin-right: 10px;
  }
}

.centerx {
  display: -webkit-box;
  display: -ms-flexbox;
  margin-right: 5px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.cell-wrap-text {
  white-space: pre-wrap !important;
}
.ag-row .ag-cell {
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center;
}
</style>



